import type {IProject} from "../../models/interfaces/project.interface.ts";
import type {IProjectDto} from "../../models/interfaces/dtos/project.dto.interface.ts";

export const transformProjectsDtoToProjects = (projectsDto: IProjectDto[]): IProject[] => {
  return projectsDto.map((projectDto: IProjectDto) => ({
    id: projectDto._id,
    path: projectDto.name,
    name: projectDto.name.split("/").pop() ?? projectDto.name,
    sourceLanguage: projectDto.sourceLanguage,
    seriesName: projectDto?.seriesName || "",
    transcription: projectDto.transcription,
    featuresStates: projectDto.featuresStates,
    mediaMeta: projectDto.mediaMeta,
    createdAt: projectDto.createdAt,
    updatedAt: projectDto.updatedAt,
    dueDate: projectDto.dueDate,
    priority: projectDto.priority,
    createdBy: projectDto.createdBy,
    dubbingScript: projectDto.dubbingScript ?? false,
    canAddLanguages: projectDto.canAddLanguages,
  }));
}
